"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = AttachmentPlugin;

var _emptyFunction = _interopRequireDefault(require("react-utils/emptyFunction"));

var _partial = _interopRequireDefault(require("transmute/partial"));

var _FileManagerApi = require("draft-plugins/api/FileManagerApi");

var _ToolbarUploadActionPlugin = _interopRequireDefault(require("./ToolbarUploadActionPlugin"));

var _immutable = require("immutable");

var DEFAULT_OPTS = {
  messageKey: 'customerDataCommunicator.attachmentOptions.upload',
  onAttachmentSelected: _emptyFunction.default,
  onAttachmentUploadStarted: _emptyFunction.default
};

function handleFileUpload(onAttachmentUploadStarted, onAttachmentSelected, onAttachmentUploadFailed) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var event = arguments.length > 4 ? arguments[4] : undefined;
  var files = event.target.files;

  if (!files || files.length === 0) {
    return;
  }

  var inProgressFiles = (0, _immutable.List)([]);
  Array.prototype.slice.call(files).forEach(function (file) {
    var fileToUpload = {
      name: file.name,
      size: file.size,
      type: file.type
    };
    inProgressFiles = inProgressFiles.push((0, _immutable.Map)(fileToUpload));
    (0, _FileManagerApi.uploadFile)(file, options).then(function (data) {
      return (0, _immutable.fromJS)(data);
    }).then(function (data) {
      var fileData = data.getIn(['objects', 0]);

      if (fileData) {
        fileData = fileData.merge({
          originalName: fileToUpload.name
        });
        onAttachmentSelected(fileData);
      }
    }, function (error) {
      return onAttachmentUploadFailed(error, (0, _immutable.Map)(fileToUpload));
    });
  });
  onAttachmentUploadStarted(inProgressFiles);
}

function AttachmentPlugin() {
  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  opts = Object.assign({}, DEFAULT_OPTS, opts);
  opts.onChange = (0, _partial.default)(handleFileUpload, opts.onAttachmentUploadStarted, opts.onAttachmentSelected, opts.onAttachmentUploadFailed, opts.fileOptions);
  return (0, _ToolbarUploadActionPlugin.default)(opts);
}

module.exports = exports.default;